import styled from "styled-components";


export const ContentFilter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 32px;
  margin-top: 1px;
`;
export const ContentFilterNewTicket = styled.div`
    display: flex;
    height: 60px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;
export const ContentExportImport = styled.div`
  display: flex;
`;
export const ContentInputAndListableTicketsDeleted = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

export const ContentInput = styled.div`
  display: flex;
  width: 100%;
`;

export const ContentInputSearch = styled.div`
  max-width: 420px;
  width: 100%;
  flex: 1;

  .input-filter-ticket-number .ant-input {
    font-size: 14px;
  }

  .input-filter-ticket-number .ant-input::placeholder {
    font-size: 14px;
  }
`;
export const ContentInputPeriod = styled.div`
  max-width: 280px;
  width: 100%;
  margin-left: 12px;
`;
export const ContentInputSearchAndFilter = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  align-items: center;
`;

export const ContentInputSearchFixed = styled.div`
   display: flex;
    flex: 1;
`;
export const ContentInputSearchAndFilterFixed = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 60px;
    min-height: 60px;
    max-height: 60px;
    justify-content: center;
`;
export const PaddingFilters = styled.div`
  padding: 0 0 0 32px;
`;

export const MarginFilters = styled.div`
    margin-right: 12px;
    display: flex;
    flex: 1;
`;
